import React from 'react';

const Separator = ({selected}) => <hr style={{
    height: 1,
    width: '100%',
    border: 0, backgroundColor: selected ? '#fff' : '#e8e8e8',
    marginTop: 5, padding: 0,
}} />

export default Separator;